import _implicitStylesheets from "./bannerV2.css";
import _implicitScopedStylesheets from "./bannerV2.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<p${"c0"} type-style="display-8"${"a0:role"}${2}>${"t1"}</p>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment} = $api;
  return [api_static_fragment($fragment1, 1, [api_static_part(0, {
    className: api_normalize_class_name($cmp.bannerClassName),
    attrs: {
      "role": $cmp.bannerRole
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.message))])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-muf1a9km7j";
tmpl.legacyStylesheetToken = "undefined-_bannerV2";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
